<section>    
    <div [class.modal-content]="model.mode=='modal' && showCard">
        <div *ngIf="model.mode=='modal' && showCard && model.titleModal" class="modal-header">
            <div>{{model.titleModal}}</div>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" (click)="close()" >
                  <i class="fas fa-times"></i>
                </button>
              </div>
        </div>
        <div [class.modal-body]="model.mode=='modal' && showCard">
            <ng-content #content></ng-content>
        </div>
        <div class="modal-footer" *ngIf="model.mode=='modal' && showCard">
            <button class="btn btn-outline-success" *ngIf="model.selecttype=='multiple'" (click)="confirmSelections()">Conferma selezione</button>
            <button class="btn btn-outline-secondary" (click)="close()"><i class="fas fa-times mr-2"></i>Chiudi<small class="KeyFunction ml-2">(ESC)</small></button>
        </div>
    </div>    
</section>